import componentState from '@/mixins/component-state'

const editState = 'isEditing'

export default {
  mixins: [componentState],
  beforeRouteLeave: function (to, from, next) {
    this._stopEditing()
    next()
  },
  methods: {
    _isEditing: function () {
      return this._get(editState) === true
    },
    _startEditing: function () {
      this._set(editState, true)
    },
    _stopEditing: function () {
      this._delete(editState)
    },
    _toggleEditing: function (content) {
      if (content && (content === true || content.length > 0)) {
        this._startEditing()
      } else {
        this._stopEditing()
      }
    }
  }
}
